import { BrowserRouter } from "react-router-dom";
import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import Illustration from "../../assets/shadab-programming.svg";
import { NavHashLink } from "react-router-hash-link";
import ShadabPortfolio from "../../assets/shadab-cv.pdf";

export function Hero() {
  return (
    <Container id='home'>
      <div className='hero-text'>
        <ScrollAnimation animateIn='fadeInUp'>
          <p>Hello 👋, I am</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInUp' delay={0.2 * 1000}>
          <h1>Shadab Alam</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInUp' delay={0.4 * 1000}>
          <h3>Full Stack Developer</h3>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInUp' delay={0.6 * 1000}>
          <p className='small-resume'>
            I'm a full-stack developer with 3+ years of experience building end-to-end web apps across front-end and back-end.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn='fadeInUp' delay={0.8 * 1000}>
          <BrowserRouter>
            <NavHashLink smooth to='#contact' className='button'>
              Contact
            </NavHashLink>
            {/* <NavHashLink smooth to={ShadabPortfolio} className='cv-button'>
              CV
            </NavHashLink> */}
          </BrowserRouter>
        </ScrollAnimation>
      </div>
      <div className='hero-image'>
        <ScrollAnimation animateIn='fadeInRight' delay={1 * 1000}>
          <img src={Illustration} alt='Ilustração' />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
